import { getApiErrorMessage } from "../../../../utils/commonFunction";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import React, { useState } from "react";

import { CountryFilter } from "./country-filter/Country";
import CountryTable from "./country-table/ContainerTable";
import DeleteDialog from "../../../../../_metronic/_partials/widgets/alert/DeleteDialog";
import NewBreadCrumbs from "../../../../../_metronic/layout/components/subheader/components/NewBreadCrumbs";
import NotAuthorized from "../../../../../_metronic/_partials/widgets/NotAuthorized";
import SnackBarTool from "../../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { deleteCountry } from "../../_redux/country/countryCrud";
import { fetchCountryList } from "../../_redux/country/countryAction";
import { initialFilter } from "./ContainerUIHelpers";
import { useDispatch } from "react-redux";
import { useContainerUIContext } from "./ContainerUIContext";
import ContainerTable from "./country-table/ContainerTable";
import { deleteContainerM } from "../../_redux/container/containerCrud";
import { fetchContainerList } from "../../_redux/container/containerAction";

const ContainerCard = ({ permission, init, intl , setOpenCanva }) => {
  const CountryUIContext = useContainerUIContext();
  const dispatch = useDispatch();
  //  This state controls the delete dialog
  const [dialog, setDialog] = useState(false);
  //  This state controls the snackbar
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });

  //  This function handles deleting countries
  const handleDelete = () => {
    //  Reset the snackbar
    setSnack({ call: false, type: "", message: "" });
    deleteContainerM({ container_id: CountryUIContext.ids })
      .then((res) => {
        //  Display a success message in the snackbar
        setSnack({ call: true, type: "success", message: res.data.message });
        dispatch(fetchContainerList(initialFilter));

        //  Close the delete dialog
        setDialog(false);
        CountryUIContext.setIds([]);
      })
      .catch((error) => {
        //  Display an error message in the snackbar
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
        //  Close the delete dialog
        setDialog(false);
      });
  };
  return (
    <>
      {/* This div displays its children with a space between them */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {/* This components shows breadcrumb */}
        <NewBreadCrumbs title={intl.formatMessage({ id: "COUNTRY" })} />
        {/* This div contains the delete and new country buttons */}
        <div>
          {permission?.setting_country?.delete ? (
            <button
              className="btn btn-primary mr-2"
              type="button"
              onClick={() => setDialog(true)}
              disabled={CountryUIContext.ids.length === 0}
            >
              Delete
            </button>
          ) : (
            ""
          )}
            <button
              
              className="btn btn-primary "
              type="button"
              onClick={()=>setOpenCanva({check:true})}
            >
              Add Container
            </button>
         
        </div>
      </div>
      {/* This card contains the country filter and table */}
      <Card>
        <CardBody>
          {permission?.setting_country?.view ? (
            <>
              <CountryFilter />
              <ContainerTable permission={permission} setOpenCanva={setOpenCanva} />
            </>
          ) : (
            <NotAuthorized />
          )}
        </CardBody>
      </Card>
      {/* This dialog allows the user to delete items */}
      <DeleteDialog
        dialog={dialog}
        setDialog={setDialog}
        handleDelete={handleDelete}
        title={"Container"}
      />
      {/* This snackbar displays error and success messages to the user */}
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </>
  );
};

export default ContainerCard;
